import logo from "../../../assets/basmala-icon-4.png";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-container" data-testid="loader-container">
      <img src={logo} className="loader-image" alt="Basmala" />
    </div>
  );
};

export default Loader;
